import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import App from './App.vue'
import './registerServiceWorker'
import './assets/css/index.css'
import './assets/css/fonts.css'

import store from "@/store/store.js";
import router from "@/router";

// quill html editor
import Quill from 'quill' // Full build
import { QuillyEditor } from 'vue-quilly'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import SemanticHTMLEditor from './components/SemanticHTMLEditor.vue'

// favicon
import { useFavicon } from '@vueuse/core'
const icon = useFavicon();
icon.value = './favicon.ico'

// google-tag
import VueGtag from "vue-gtag";

// i18n locale files
import en from '@/locales/en.json'
import da from '@/locales/da.json'

const i18n = createI18n({
  locale: 'da',
  fallbackLocale: 'en',
  messages: { en, da }
})

const app = createApp(App);

app.use(store);
app.use(router);
app.use(VueGtag, {
  appName: process.env.VUE_APP_GTAG_NAME,
  pageTrackerScreenviewEnabled: true,
  config: { id: process.env.VUE_APP_GTAG }}, router)
app.use(i18n)

app.component('SemanticHTMLEditor', SemanticHTMLEditor)

router.isReady().then(() => {
  app.mount("#app");
});
